import FormMixin from '@/vue/mixins/form.mixin'
import ErrorMessage from '@/vue/common/ErrorMessage'
import Loader from '@/vue/common/Loader'

import { api } from '@/api'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { RoleRecord } from '@/js/records/entities/role.record'
import { vueRoutes } from '@/vue-router/routes'
import { Bus } from '@/js/helpers/event-bus'

const REQUEST_TYPES = {
  addRole: 'add_role',
  updateRole: 'update_role',
  changeRole: 'change_role_permissions',
}

export default {
  components: {
    ErrorMessage,
    Loader,
  },
  props: {
    roleDetails: { type: RoleRecord, default: () => new RoleRecord() },
  },
  data () {
    return {
      isLoaded: false,
      isFailed: false,
      isDisabled: false,
      role: this.roleDetails,
      resources: [],
      actions: [],
      roles: [],
      form: {
        name: '',
        description: '',
      },
    }
  },

  mixins: [FormMixin],

  methods: {
    async loadRoles () {
      this.isLoaded = false
      this.isFailed = false

      try {
        const { data } = await api.getWithSignature('/roles?page[order]=asc')
        this.roles = data.map(i => new RoleRecord(i))
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      }

      this.isLoaded = true
    },

    async loadResources () {
      this.isLoaded = false
      this.isFailed = false

      try {
        const { data } = await api.getWithSignature('/permissions/resources')
        this.resources = data.permissionResources
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      }

      this.isLoaded = true
    },

    async loadActions () {
      this.isLoaded = false
      this.isFailed = false

      try {
        const { data } = await api.getWithSignature('/permissions/actions')
        this.actions = data.permissionActions
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      }

      this.isLoaded = true
    },

    async getRoleById (id) {
      this.isLoaded = false

      try {
        let { data } = await api.getWithSignature(`/roles/${id}`)
        this.role = new RoleRecord(data)
      } catch (error) {
        this.isFailed = true
        ErrorHandler.processWithoutFeedback(error)
      }

      this.isLoaded = true
    },

    async createRole () {
      this.isDisabled = true

      try {
        const body = JSON.stringify({
          data: {
            type: REQUEST_TYPES.addRole,
            attributes: {
              name: this.form.name,
              description: this.form.description,
            },
          },
        })

        await api.postWithSignature('/roles', body)
        Bus.success('role-details.success-create-message')
      } catch (error) {
        ErrorHandler.processWithoutFeedback(error)
        Bus.error('status-message.default-message_error')
      }

      this.isDisabled = false
    },

    async updateRole (id) {
      this.isDisabled = true

      const formattedPerms = this.role.formatPermissions()

      const body = JSON.stringify({
        data: {
          type: REQUEST_TYPES.updateRole,
          attributes: {
            name: this.role.name,
            description: this.role.description,
            permissions: formattedPerms,
          },
        },
      })

      try {
        await api.putWithSignature(`/roles/${id}`, body)
        Bus.success('role-details.success-update-message')
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        Bus.error('status-message.default-message_error')
      }

      this.isDisabled = false
    },

    async addAction (id, action, resource) {
      this.isDisabled = true

      const body = JSON.stringify({
        data: {
          type: REQUEST_TYPES.changeRole,
          attributes: {
            permissions: [{
              action: action,
              resource: resource,
            }],
          },
        },
      })

      try {
        await api.postWithSignature(`/roles/${id}/permissions`, body)
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }

      this.isDisabled = false
    },

    async deleteAction (id, action, resource) {
      this.isDisabled = true

      const body = JSON.stringify({
        data: {
          type: REQUEST_TYPES.changeRole,
          attributes: {
            permissions: [{
              action: action.type,
              resource: resource,
            }],
          },
        },
      })

      try {
        await api.deleteWithSignature(`/roles/${id}/permissions`, body)
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      }

      this.isDisabled = false
    },

    redirectToRoleDetails (id) {
      this.$router.push({
        name: vueRoutes.roleDetails.name,
        params: { id },
      })
    },

    retirectToRoleCreate () {
      this.$router.push({ name: vueRoutes.roleCreate.name })
    },
  },
}
